import { render, staticRenderFns } from "./PopupBaseApprovalDetail.vue?vue&type=template&id=03d4b63b&"
import script from "./PopupBaseApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./PopupBaseApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopupBaseApprovalDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports